import { Box, Button, Dialog, Typography } from '@mui/material';
import { t } from 'i18next';
import { ButtonBlue } from '../Commons';

type Props = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

const LogoutConfirmation = ({ open, onClose, onConfirm }: Props) => {
  return (
    <Dialog open={open} maxWidth="sm" onClose={onClose}>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
        p={4}
      >
        <Typography
          align="center"
          sx={{
            py: 4,
            px: 6
          }}
          variant="h3"
        >
          {t(' Are you sure you want to logout?')}
        </Typography>

        <Box>
          <Button
            variant="text"
            sx={{
              mx: 1,
              px: 5
            }}
            onClick={onClose}
            color={'primary'}
          >
            {t('Cancel')}
          </Button>
          <ButtonBlue
            onClick={onConfirm}
            sx={{
              mx: 1,
              px: 5
            }}
            variant="contained"
          >
            {t('Yes')}
          </ButtonBlue>
        </Box>
      </Box>
    </Dialog>
  );
};

export default LogoutConfirmation;
